import config from "@/config"
import http from "@/utils/request"
import { get } from "sortablejs";

export default {

    GetPediatricCasesEnumList: {
        url: `${config.API_URL}/System/PediatricCases/GetPediatricCasesEnumList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetPediatricCasesList: {
        url: `${config.API_URL}/System/PediatricCases/GetPediatricCasesList`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, DiagnosticInformationChange: {
        url: `${config.API_URL}/System/DiagnosticInformation/DiagnosticInformationChange`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }
    , GetPediatricCasesById: {
        url: `${config.API_URL}/System/PediatricCases/GetPediatricCasesById`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
    , ChangePediatricCases: {
        url: `${config.API_URL}/System/PediatricCases/ChangePediatricCases`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, DeletePediatricCasesById: {
        url: `${config.API_URL}/System/PediatricCases/DeletePediatricCasesById`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }
    , GetDiagnosticInformationByPatientId: {
        url: `${config.API_URL}/System/DiagnosticInformation/GetDiagnosticInformationByPatientId`,
        name: "",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    PostDoctorPatientRelation: {
        url: `${config.API_URL}/System/DoctorPatientRelation/PostDoctorPatientRelation`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    GetDoctorPatientRelationList: {
        url: `${config.API_URL}/System/DoctorPatientRelation/GetDoctorPatientRelationList`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    DeleteDoctorPatientRelation: {
        url: `${config.API_URL}/System/DoctorPatientRelation/DeleteDoctorPatientRelation`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    GetRevieDoctorPatientRelationList: {
        url: `${config.API_URL}/System/DoctorPatientRelation/GetRevieDoctorPatientRelationList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetRevieDoctorPatientRelationById: {
        url: `${config.API_URL}/System/DoctorPatientRelation/GetRevieDoctorPatientRelationById`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, RevieDoctorPatientRelation: {
        url: `${config.API_URL}/System/DoctorPatientRelation/RevieDoctorPatientRelation`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, GetToothDefualList: {
        url: `${config.API_URL}/System/PediatricCases/GetToothDefualList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    DiagnosticInformationById: {
        url: `${config.API_URL}/System/DiagnosticInformation/DiagnosticInformationById`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetSysUserList: {
        url: `${config.API_URL}/System/User/GetSysUserList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, UserDelete: {
        url: `${config.API_URL}/System/User/UserDelete`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
    , GetUserById: {
        url: `${config.API_URL}/System/User/GetUserById`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, UserChange: {
        url: `${config.API_URL}/System/User/UserChange`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, AdminAccountVerification: {
        url: `${config.API_URL}/System/User/AdminAccountVerification`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, GetExamineLogList: {
        url: `${config.API_URL}/System/User/GetExamineLogList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetAreasList: {
        url: `${config.API_URL}/System/Areas/GetAreasList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
    , GetEducationInfoList: {
        url: `${config.API_URL}/System/EducationInfo/GetEducationInfoList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
    , GetEducationInfoById: {
        url: `${config.API_URL}/System/EducationInfo/GetEducationInfoById`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }
    , DeleteEducationInfoById: {
        url: `${config.API_URL}/System/EducationInfo/DeleteEducationInfoById`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }
    , PostEducationInfo: {
        url: `${config.API_URL}/System/EducationInfo/PostEducationInfo`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, GetAskQuestionList: {
        url: `${config.API_URL}/System/AskQuestion/GetAskQuestionList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, PostAskQuestionBack: {
        url: `${config.API_URL}/System/AskQuestion/PostAskQuestionBack`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }, GetAskQuestionById: {
        url: `${config.API_URL}/System/AskQuestion/GetAskQuestionById`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetCaseJudgeFieldList: {
        url: `${config.API_URL}/System/CaseJudge/GetCaseJudgeFieldList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetCaseJudgeById: {
        url: `${config.API_URL}/System/CaseJudge/GetCaseJudgeById`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    PostCaseJudgeBack: {
        url: `${config.API_URL}/System/CaseJudge/PostCaseJudgeBack`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    DeleteCaseJudgeById: {
        url: `${config.API_URL}/System/CaseJudge/DeleteCaseJudgeById`,
        name: "删除医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    GetCaseJudgeList: {
        url: `${config.API_URL}/System/CaseJudge/GetCaseJudgeList`,
        name: "删除医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetParentalRelationList: {
        url: `${config.API_URL}/System/EducationInfo/GetParentalRelationList`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },

    GetRecommendedContentList: {
        url: `${config.API_URL}/System/RecommendedContent/GetRecommendedContentList`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    PostRecommendedContent: {
        url: `${config.API_URL}/System/RecommendedContent/PostRecommendedContent`,
        name: "医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    GetRecommendedContentById: {
        url: `${config.API_URL}/System/RecommendedContent/GetRecommendedContentById`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    DeleteRecommendedContentById: {
        url: `${config.API_URL}/System/RecommendedContent/DeleteRecommendedContentById`,
        name: "医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    GetUserTestTeechDetailByPatientId: {
        url: `${config.API_URL}/System/PediatricCases/GetUserTestTeechDetailByPatientId`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetAgreementContentList: {
        url: `${config.API_URL}/System/EducationInfo/GetAgreementContentList`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
     PostAgreementContent: {
        url: `${config.API_URL}/System/EducationInfo/PostAgreementContent`,
        name: "医患关系",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
     GetAgreementContentById: {
        url: `${config.API_URL}/System/EducationInfo/GetAgreementContentById`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
     GetUserTestTeechList: {
        url: `${config.API_URL}/Web/PediatricCases/GetUserTestTeechList`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    GetSystemUserTestTeechList: {
        url: `${config.API_URL}/System/PediatricCases/GetUserTestTeechList`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    }, 
    GetUserTestTeechDetailById: {
        url: `${config.API_URL}/System/PediatricCases/GetUserTestTeechDetailById`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
       GetExportExcel: {
        url: `${config.API_URL}/System/Export/GetExportExcel`,
        name: "医患关系",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
}